<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img
        class="dressup1"
        src="https://resource.3uplay.com/sys-feed/6d316436-2870-4334-b559-b872d308b7592552864018704782351.webp"
        alt=""
      />
      <img
        class="dressup2"
        src="https://resource.3uplay.com/sys-feed/2e9cc2a2-fc9c-4e90-aead-f80795cb14bd6234255569827482124.webp"
        alt=""
      />
      <img
        class="dressup3"
        src="https://resource.3uplay.com/sys-feed/ec6803d3-1296-4e0b-bc67-ecae990244b86547097637926623759.webp"
        alt=""
      />
      <img
        class="dressup4"
        src="https://resource.3uplay.com/sys-feed/f9bb4487-5850-4a90-b46e-10188676621d3008916707130154791.webp"
        alt=""
      />
      <div class="tab-box">
        <img
          src="./images/tab1-active.png"
          alt=""
          class="tab1 tab"
          v-show="activeIndex === 1"
          @click="checkScoreList(1)"
        />
        <img
          src="./images/tab1.png"
          alt=""
          class="tab1 tab"
          v-show="activeIndex === 2"
          @click="checkScoreList(1)"
        />
        <img
          src="./images/tab2-active.png"
          alt=""
          class="tab2 tab"
          v-show="activeIndex === 2"
          @click="checkScoreList(2)"
        />
        <img
          src="./images/tab2.png"
          alt=""
          class="tab2 tab"
          v-show="activeIndex === 1"
          @click="checkScoreList(2)"
        />
      </div>
      <div class="week-score">{{ isPlayer ? weekScore : '---' }}</div>
      <div class="all-score">{{ isPlayer ? totalScore : '---' }}</div>
      <div class="top3-box" v-show="activeIndex === 2">
        <div
          v-for="(item, index) of topList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img
            src="./images/1.png"
            class="rank-img rank-img1"
            v-if="index == 1"
          />
          <img
            src="./images/2.png"
            class="rank-img rank-img2"
            v-if="index == 0"
          />
          <img
            src="./images/3.png"
            class="rank-img rank-img3"
            v-if="index == 2"
          />
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">{{ item.user_nickname }}</div>
          <div class="score">{{ item.jifen }}</div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 2">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right">
            <span>
              已獲得
            </span>
            <img class="icon" src="./images/icon.png" alt="" />
            <span class="scroe"> {{ item.jifen }}</span>
          </div>
        </div>
      </div>
      <div class="top3-box" v-show="activeIndex === 1">
        <div
          v-for="(item, index) of topWeekList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img
            src="./images/1.png"
            class="rank-img rank-img1"
            v-if="index == 1"
          />
          <img
            src="./images/2.png"
            class="rank-img rank-img2"
            v-if="index == 0"
          />
          <img
            src="./images/3.png"
            class="rank-img rank-img3"
            v-if="index == 2"
          />
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">{{ item.user_nickname }}</div>
          <div class="score">
            {{ item.jifen }}
          </div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 1">
        <div
          class="item"
          v-for="(item, index) of weekList.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right">
            <span>
              已獲得
            </span>
            <img class="icon" src="./images/icon.png" alt="" />
            <span class="scroe"> {{ item.jifen }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      list: [],
      weekList: [],
      myScore: 0,
      activeIndex: 1,
      totalScore: 0,
      weekScore: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    topList() {
      return this.list && this.list.length
        ? [this.list[1], this.list[0], this.list[2]]
        : [];
    },
    topWeekList() {
      return this.weekList && this.weekList.length
        ? [this.weekList[1], this.weekList[0], this.weekList[2]]
        : [];
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getAllList() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/liuqi/voice/all/rank';
        const { data } = await this.$http.get(url);
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getWeekList() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/liuqi/voice/week/rank';
        const { data } = await this.$http.get(url);
        this.weekList = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/jifen/liuqi/voice/rank/${uuid}`;
        const { data } = await this.$http.get(url);
        if (data) {
          this.totalScore = data.jifen_total || 0;
          this.weekScore = data.jifen_week || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    checkScoreList(index) {
      this.activeIndex = index;
    }
  },
  created() {
    this.getWeekList();
    this.getAllList();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #fff7e8;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2,
    .dressup3,
    .dressup4 {
      position: absolute;
      font-size: 0;
      width: 100px;
      height: auto;
      top: 763px;
    }
    .dressup1 {
      left: 152px;
    }
    .dressup2 {
      left: 339px;
      top: 774px;
    }
    .dressup3 {
      left: 545px;
    }
    .dressup4 {
      left: 728px;
      top: 774px;
    }
    .tab-box {
      position: absolute;
      top: 2224px;
      left: 655px;
      transform: translateX(-50%);
      display: flex;
      border-radius: 21px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      .tab1,
      .tab2 {
        line-height: 42px;
        font-size: 21px;
        text-align: center;
        width: 150px;
        height: auto;
      }
      .tab1 {
        margin-right: -10px;
        z-index: 2;
      }
      .tab2 {
        margin-left: -11px;
      }
    }
    .week-score,
    .all-score {
      position: absolute;
      color: white;
      font-size: 28px;
      font-weight: 600;
      padding: 4px 10px;
      height: 55px;
      z-index: 2;
      text-align: center;
      width: 273px;
      top: 2313px;
      display: flex;
      align-items: center;
      justify-content: center;
      left: 73px;
    }
    .all-score {
      top: 2416px;
    }
    .top3-box {
      position: absolute;
      top: 2326px;
      display: flex;
      left: 402px;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 20px;
        flex: none;
        color: white;
        width: 145px;
        margin: 0 11px;
        margin-top: 98px;
        position: relative;
        .rank-img {
          position: absolute;
          top: 63px;
          height: 29px;
          width: auto;
          left: 99px;
        }
        .rank-img1 {
          top: 57px;
          height: 45px;
          left: 98px;
        }
        .head-portrait {
          border-radius: 50%;
          object-fit: cover;
          width: 82px;
          height: 82px;
          margin-bottom: 20px;
          border: 3px black solid;
        }
        .user-name,
        .score {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          text-align: center;
        }
        .user-name {
          margin-top: 6px;
          color: #5c0f5e;
          font-size: 20px;
        }
        .score {
          margin-top: 12px;
          text-align: left;
          padding-left: 78px;
        }
        // &.top1 {
        //   margin-top: 30px;
        // }
        &.top2 {
          margin-top: 18px;
          .head-portrait {
            margin-left: 2px;
          }
          .user-name {
            margin-top: 20px;
          }
        }
        &.top3,
        &.top1 {
          margin-top: 50px;
          color: white;
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: 2647px;
      right: 148px;
      width: 393px;
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 20px;
        margin-bottom: 11px;
        color: black;
        height: 67px;
        border-radius: 40px;
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .left {
          .index {
            margin-right: 20px;
            width: 17px;
            text-align: right;
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            object-fit: cover;
            border: 3px solid black;
            margin-right: 20px;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 156px;
          }
        }
        .right {
          span,
          img {
            flex: none;
          }
          img {
            width: dPx(16);
            height: auto;
            margin: 0 dPx(6);
          }
        }
        // .right {
        //   width: 200px;
        //   display: flex;
        //   align-items: center;
        //   justify-content: flex-start;
        //   img {
        //     width: 24px;
        //     margin: 0 3px;
        //     margin-left: 20px;
        //   }
        // }
      }
    }
  }
}
</style>
